import { Injectable } from '@angular/core';
import { ContentApi } from '../api/content.api';
import { EdlHtmlContent } from '../model/content.model';

@Injectable()
export class ContentService {
  constructor(private contentApi: ContentApi) { }

  getLandingPageContent = () =>
    this.contentApi.getLandingPageContent();

  saveContent = (content: EdlHtmlContent) =>
    this.contentApi.saveContent(content);


}
